import geolocationSlice from './geolocationSlice'

export {
  onClearGeolocation,
  selectGeolocation,
  updateGeolocation
} from './geolocationSlice'

export default geolocationSlice
